var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoftwareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1424_16128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2846 0.572266H1.71317C1.41007 0.572266 1.11937 0.692673 0.905048 0.907001C0.69072 1.12133 0.570313 1.41202 0.570312 1.71512V14.2866C0.570313 14.5897 0.69072 14.8803 0.905048 15.0947C1.11937 15.309 1.41007 15.4294 1.71317 15.4294H14.2846C14.5877 15.4294 14.8784 15.309 15.0927 15.0947C15.307 14.8803 15.4275 14.5897 15.4275 14.2866V1.71512C15.4275 1.41202 15.307 1.12133 15.0927 0.907001C14.8784 0.692673 14.5877 0.572266 14.2846 0.572266Z",
    stroke: "#393939",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.570312 4H15.4275",
    stroke: "#393939",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8549 9.71484H5.14062",
    stroke: "#393939",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6.85938V12.5737",
    stroke: "#393939",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1424_16128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareIcon);
export default __webpack_public_path__ + "static/media/software-icon.4225c9fa2356a7739a26c3dda3c003bb.svg";
export { ForwardRef as ReactComponent };